import React from 'react';
import styles from './Hero.module.css';

const Hero = () => {
  const currentCity = window.location.hostname.split('.')[0];
  const isMainSite = currentCity === 'regioncheck';

  return (
    <section className={styles.hero}>
      <div className={styles.heroBackground}></div>
      <div className="container">
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>
            {isMainSite ? (
              <>
                Официальные чеки для командировок<br />
                по всей России
              </>
            ) : (
              <>
                Гостиничные чеки в {currentCity.charAt(0).toUpperCase() + currentCity.slice(1)}<br />
                с QR-кодом
              </>
            )}
          </h1>
          <p className={styles.heroSubtitle}>
            Предоставляем официальные командировочные документы от действующих гостиниц.<br />
            Быстрая доставка, полный пакет документов, легальное оформление.
          </p>
          <div className={styles.heroButtons}>
            {isMainSite ? (
              <a href="#regions" className="btn btn-primary">
                <i className="fa fa-map-marker"></i> Выбрать город
              </a>
            ) : (
              <a href="#contact" className="btn btn-primary">
                <i className="fa fa-whatsapp"></i> Заказать чек
              </a>
            )}
            <a href="#features" className="btn btn-secondary">
              <i className="fa fa-star"></i> Наши преимущества
            </a>
          </div>
        </div>
      </div>
      <div className={styles.heroDivider}></div>
    </section>
  );
};

export default Hero;